import React from 'react';
import { cn } from '@/utils/styles';

interface ConditionScoreCardProps {
  name: string;
  score: number;
  rank: string;
  rankColor: string;
  onClick?: () => void;
}

export const ConditionScoreCard: React.FC<ConditionScoreCardProps> = ({
  name,
  score,
  rank,
  rankColor,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'p-4 rounded-lg flex shadow-md bg-[#42434D73] hover:shadow-lg transition-shadow w-full min-h-[78px] text-left',
      )}
    >
      <div className="w-full">
        <div className="flex justify-between items-center">
          <div>
            <h3 className="typography-title text-primary truncate">{name}</h3>
            <p
              className="typography-caption1 mt-1"
              style={{ color: rankColor }}
            >
              {rank}
            </p>
          </div>
          <span className="typography-d2 text-secondary mr-2">{score}</span>
        </div>
      </div>
    </button>
  );
};